import { MessageDescriptor, defineMessages } from "react-intl";
import { BulkProductUploadReportCsvColumns } from "./BulkProductUploadReportCsvColumns";

export const BULK_PRODUCT_UPLOAD_REPORT_CSV_HEADERS: Record<BulkProductUploadReportCsvColumns, MessageDescriptor> =
  defineMessages({
    [BulkProductUploadReportCsvColumns.ROW_NUMBER]: {
      id: "inbounds.bulkUpload.csvHeader.rowNumber",
      defaultMessage: "Row Number",
    },
    [BulkProductUploadReportCsvColumns.STATUS]: {
      id: "inbounds.bulkUpload.csvHeader.status",
      defaultMessage: "Status",
    },
    [BulkProductUploadReportCsvColumns.MERCHANT_SKU]: {
      id: "inbounds.bulkUpload.csvHeader.merchantSku",
      defaultMessage: "Merchant SKU (MSKU)",
    },

    [BulkProductUploadReportCsvColumns.DSKU]: {
      id: "inbounds.bulkUpload.csvHeader.dsku",
      defaultMessage: "DSKU",
    },
    [BulkProductUploadReportCsvColumns.UNITS_PER_BOX]: {
      id: "inbounds.bulkUpload.csvHeader.unitsPerBox",
      defaultMessage: "Units Per Box",
    },
    [BulkProductUploadReportCsvColumns.NUMBER_OF_BOXES]: {
      id: "inbounds.bulkUpload.csvHeader.numberOfBoxes",
      defaultMessage: "Number of Boxes",
    },
    [BulkProductUploadReportCsvColumns.TOTAL_UNITS]: {
      id: "inbounds.bulkUpload.csvHeader.totalUnits",
      defaultMessage: "Total Units",
    },
    [BulkProductUploadReportCsvColumns.LOT_NUMBER]: {
      id: "inbounds.bulkUpload.csvHeader.lotNumber",
      defaultMessage: "Lot Number",
    },
    [BulkProductUploadReportCsvColumns.ERROR_MESSAGE]: {
      id: "inbounds.bulkUpload.csvHeader.errorMessage",
      defaultMessage: "Error Message",
    },
    [BulkProductUploadReportCsvColumns.ERROR_CODE]: {
      id: "inbounds.bulkUpload.csvHeader.errorCode",
      defaultMessage: "Error Code",
    },
  });
